import React, { useState } from "react";
import { infoServicio } from "modAws/CatalogoAws";
import RETOS from "../aprende/retos";
import CuadroDiagrama from "./CuadroDiagrama";

// Retos de decision: se lee una situacion, se elige una opcion y se explica por que sirve o no, con el dibujo de la solucion.
const Retos = ({ onServicio }) => {
    const [i, setI] = useState(0);
    const [resp, setResp] = useState({});          // indice de reto -> opcion elegida
    const r = RETOS[i];
    const elegida = resp[i];
    const aciertos = Object.entries(resp).filter(([k, v]) => RETOS[k].opciones[v].ok).length;
    const respondidos = Object.keys(resp).length;
    return (
        <div className="card mb-3" style={{ borderTop: "4px solid #E7157B" }} data-guia="reto">
            <div className="card-body">
                <div className="d-flex align-items-center flex-wrap gap-2 mb-1">
                    <div className="text-muted small me-auto"><i className="fa fa-bullseye me-1" />Retos de decisión · reto {i + 1} de {RETOS.length}</div>
                    <span className="badge text-bg-light">Aciertos: {aciertos} de {respondidos}</span>
                </div>
                <h4>{r.titulo}</h4>
                <p style={{ fontSize: 17 }}>{r.situacion}</p>
                <div className="d-grid gap-2 mb-2">
                    {r.opciones.map((o, k) => {
                        const ok = elegida != null && o.ok, mal = elegida === k && !o.ok;
                        return (
                            <button key={k} className={`btn text-start ${ok ? "btn-success" : mal ? "btn-danger" : "btn-outline-secondary"}`} disabled={elegida != null && !ok && !mal} onClick={() => elegida == null && setResp({ ...resp, [i]: k })}>
                                {ok && <i className="fa fa-check me-2" />}{mal && <i className="fa fa-times me-2" />}{o.t}
                            </button>
                        );
                    })}
                </div>
                {elegida != null && (
                    <div className="mt-3">
                        <div className={`alert ${r.opciones[elegida].ok ? "alert-success" : "alert-warning"} py-2 mb-3`}>
                            <b>{r.opciones[elegida].ok ? "¡Muy bien!" : "No es la mejor opción."}</b> {r.opciones[elegida].por}
                            {!r.opciones[elegida].ok && <div className="mt-1"><b>La mejor opción:</b> {r.opciones.find(o => o.ok).t}. {r.opciones.find(o => o.ok).por}</div>}
                        </div>
                        <CuadroDiagrama key={r.id} patron="libre" nodos={r.solucion.nodos} flujos={r.solucion.flujos} color="#E7157B" titulo="La solución, en un dibujo" permitirFalla={false} />
                        <p className="small mb-2">{r.solucion.texto}</p>
                        <div className="small">
                            <span className="text-muted me-2">Servicios:</span>
                            {r.servicios.filter(id => infoServicio(id)).map(id => (
                                <button key={id} className="btn btn-sm btn-outline-secondary py-0 me-1" onClick={() => onServicio && onServicio(id)}>
                                    <i className={`${infoServicio(id).servicio.icon} me-1`} style={{ color: infoServicio(id).color }} />{infoServicio(id).servicio.title}
                                </button>
                            ))}
                        </div>
                    </div>
                )}
                <div className="d-flex justify-content-between mt-3">
                    <button className="btn btn-outline-secondary" disabled={i === 0} onClick={() => setI(i - 1)}><i className="fa fa-chevron-left me-1" />Anterior</button>
                    {respondidos === RETOS.length && i === RETOS.length - 1
                        ? <span className="fw-bold align-self-center">Terminaste: {aciertos} de {RETOS.length} aciertos</span>
                        : <button className="btn btn-primary" disabled={i === RETOS.length - 1} onClick={() => setI(i + 1)}>{elegida == null ? "Saltar" : "Siguiente"}<i className="fa fa-chevron-right ms-1" /></button>}
                </div>
            </div>
        </div>
    );
};

export default Retos;
